import axios from "axios";
import Qs from "qs";
import router from "@/router";
import {
    Message
} from 'element-ui';
export default {
    //根据refresh_token重新获取token
    refreshToken() {
        if (window.location.pathname != "/login" && window.location.pathname != "/report/login" && window.location.pathname != "/register") {
            axios({
                    method: "post",
                    url: window.g.API_LOGIN + "/oauth2/token",
                    transformRequest: [
                        function(data) {
                            //在请求之前对data传参进行格式转换
                            data = Qs.stringify(data);
                            return data;
                        }
                    ],
                    params: {},
                    data: {
                        refresh_token: localStorage.getItem(
                            "mobile_internet_writing_refresh_token"
                        ),
                        grant_type: "refresh_token"
                    }
                })
                .then(response => {
                    if (response.status == 200) {
                        localStorage.setItem(
                            "mobile_internet_writing_accessToken",
                            response.data.token_type + " " + response.data.access_token
                        );
                        localStorage.setItem(
                            "mobile_internet_writing_expires",
                            response.data.expires_in
                        );
                        localStorage.setItem(
                            "mobile_internet_writing_newsExpires",
                            response.data.expires_in
                        );
                        localStorage.setItem(
                            "mobile_internet_writing_refresh_token",
                            response.data.refresh_token
                        );
                    } else {
                        Message.error("获取令牌失败，请重新登录！");
                        if (urlParam.getUrlParam('report') == 1) {
                            router.push("/report/login")
                        } else {
                            router.push("/login")
                        }
                    }
                })
                .catch(error => {
                    Message.error("获取令牌失败，请重新登录！");
                    if (urlParam.getUrlParam('report') == 1) {
                        router.push("/report/login")
                    } else {
                        router.push("/login")
                    }
                });
        }
    },
    //清空token相关localStorage
    removeLS() {
        localStorage.removeItem('mobile_internet_writing_accessToken')
        localStorage.removeItem('mobile_internet_writing_expires')
        localStorage.removeItem('mobile_internet_writing_refresh_token')
        localStorage.removeItem('mobile_internet_writing_newsExpires')
        localStorage.removeItem('flag')
        localStorage.removeItem('radioAsc')
        localStorage.removeItem('startDate')
        localStorage.removeItem('endDate')
        localStorage.removeItem('patName')
        localStorage.removeItem('statusValue')
        localStorage.removeItem('numberValue')
        localStorage.removeItem('UserDes')
        localStorage.removeItem('reportList')
        localStorage.removeItem('modalityListValue')
        localStorage.removeItem('patientTypeValue')
        localStorage.removeItem('checkPointValue')
        localStorage.removeItem('depListValue')
        localStorage.removeItem('Xno')
        localStorage.removeItem('depListValue2')
        localStorage.removeItem('statusValue2')
        localStorage.removeItem('patientTypeValue2')
        localStorage.removeItem('path')
        localStorage.removeItem('currentHospitalCode')
    }
}


// WEBPACK FOOTER //
// ./src/api/refreshTokenExpiration.js